import Cookies from "js-cookie";
import router from "@/router";
import store from "@/store";
import Vue from "vue";
import jwt_decode from "jwt-decode";

const params = { sameSite: "None", secure: true };

export function getToken() {
  var token = Cookies.get("Admin-Token");
  return token != undefined && token != "" ? token : false;
}

export function getFullName() {
  var fullName = Cookies.get("fullName");
  return fullName != undefined ? fullName : "";
}

export function getNumSystem() {
  var numSystem = Cookies.get("numSystem");
  return numSystem != undefined ? numSystem : "";
}

export function getAutoDelivery() {
  var autoDelivery = Cookies.get("autoDelivery");
  return autoDelivery == "1" || autoDelivery == undefined;
}

export function getReturnUrl() {
  var url = Cookies.get("url");

  return url != undefined ? url : "/index";
}

export function getImage() {
  return Cookies.get("image");
}

export function getFirebase() {
  var firebase = Cookies.get("firebase");
  return firebase != undefined && firebase != "" ? firebase : false;
}

export function getBranches() {
  var branches = Cookies.get("branches");
  try {
    return JSON.parse(branches);
  } catch (e) {
    return [];
  }
}

export function getPermissions() {
  var permissions = Cookies.get("permissions");
  try {
    return JSON.parse(permissions);
  } catch (e) {
    return [];
  }
}

export function getCurrentBranch() {
  var currentBranch = Cookies.get("currentBranch");

  return currentBranch != undefined && currentBranch != ""
    ? JSON.parse(currentBranch)
    : false;
}

export function getCurrentRole() {
  var key = Cookies.get("currentRole");
  return key != undefined && key != "" ? JSON.parse(key) : false;
}

export function setToken(token) {
  Cookies.set("Admin-Token", token, params);
  if (token.length > 0) {
    var decoded = jwt_decode(token);
    Cookies.set("branches", decoded.AllowBranch, params);
    Cookies.set("permissions", decoded.Permission, params);
    Cookies.set("roles", decoded.Role, params);
  }
}

export function setBranches(allowed, permissions) {
  Cookies.set("branches", allowed, params);
  Cookies.set("permissions", permissions, params);
}

export function setFirebase(firebase) {
  Cookies.set("firebase", firebase, params);
}

export function setAutoDelivery(autoDelivery) {
  Cookies.set("autoDelivery", autoDelivery ? "1" : "0", params);
}

export function setCurrentBranch(currentBranch) {
  Cookies.set("currentBranch", currentBranch, params);
}

export function setUrlKey(url) {
  Cookies.set("url", url, params);
}

export function setSlider(fullName, numSystem, imageUrl) {
  Cookies.set("fullName", fullName, params);
  Cookies.set("numSystem", numSystem, params);
  Cookies.set("image", imageUrl, params);
}

export function setCurrentRole(role) {
  Cookies.set("currentRole", role, params);
}

export function removeToken() {
  Cookies.remove("fullName", params);
  Cookies.remove("numSystem", params);
  Cookies.remove("image", params);
  Cookies.remove("firebase", params);
  Cookies.remove("branches", params);
  Cookies.remove("permissions", params);
  Cookies.remove("roles", params);
  Cookies.remove("Admin-Token", params);
  Cookies.remove("currentRole", params);
  Cookies.remove("autoDelivery", params);

  Cookies.remove("idsrv.session");
}

export function removeUrlKey() {
  Cookies.remove("url", params);
}

export function removeCurrentBranch() {
  Cookies.remove("currentBranch", params);
}

export function hasAdminPermission() {
  var roles = Cookies.get("roles");
  return roles != undefined && roles.split(",").indexOf("admin") >= 0;
}

export function hasReporterPermission() {
  var roles = Cookies.get("roles");
  return roles != undefined && roles.split(",").indexOf("reporter") >= 0;
}

export function hasModirPermission() {
  return (
    (hasAdminPermission() && getCurrentBranch()) ||
    (getCurrentRole() &&
      getCurrentRole().type == "role" &&
      parseInt(getCurrentRole().Role) <= 1)
  );
}

export function hasModirAdminPermission() {
  return hasAdminPermission() && getCurrentBranch();
}

export function hasHesabdarPermission() {
  return (
    (hasAdminPermission() && getCurrentBranch()) ||
    (getCurrentRole() &&
      getCurrentRole().type == "role" &&
      parseInt(getCurrentRole().Role) <= 2)
  );
}

export function hasAshpazPermission() {
  return (
    (hasAdminPermission() && getCurrentBranch()) ||
    (getCurrentRole() &&
      getCurrentRole().type == "role" &&
      parseInt(getCurrentRole().Role) <= 3)
  );
}

export function hasUserPermission() {
  return (
    getCurrentRole() &&
    getCurrentRole().type == "enduser" &&
    !getCurrentBranch()
  );
}

export function logout() {
  if (getToken()) {
    store.dispatch("LogOut").then(() => {});
  }
}
const whiteList = ["/loginWithOpenID", "/", ""]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  store.commit("SET_PROGRESS_SHOW", false);

  if (whiteList.indexOf(to.path) == -1 && !getToken()) {
    setUrlKey(to.path);
    next({ name: "OpenID" });
  } else if (whiteList.indexOf(to.path) !== -1 && getToken()) {
    next({ name: "Index" });
  }
  next();
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "تغذیه";
  });
});
